import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { request } from 'http';

@Injectable({
  providedIn: 'root'
})
export class NihlComparisonService {

  constructor(
    public apiService: ApiService
  ) { }

  public compareAudiogram(requestParam: {}): Observable<any> {
    return this.apiService.postService('nihl/compare-audiograms', requestParam);
  }

  public getAvgCompositeData(requestParam: {}): Observable<any> {
    return this.apiService.postService('nihl/audiometry/average-composite', requestParam);
  }

  public saveAsNewAudiometry(requestParam: {}): Observable<any> {
    return this.apiService.postService('nihl/audiometry/save', requestParam);
  }

  public saveAudiogramComparisonData(requestParam: {}): Observable<any> {
    return this.apiService.postService('nihl/audiometry/update', requestParam);
  }
  
}
